export enum ChatbotMessageRole {
  assistant = 'assistant',
  user = 'user',
}
